import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 7.393 12.707 a 1 1 0 0 1 0 -1.414 l 4.8 -4.8 a 1 1 0 1 1 1.414 1.414 L 9.514 12 l 4.093 4.093 a 1 1 0 0 1 -1.414 1.414 l -4.8 -4.8 Z"
  />,
  'ChevronLeft'
)
